import { call, put, takeEvery } from "redux-saga/effects";

import Branches from "services/branches";
import {
  fetchBranchesRequested,
  fetchBranchesFailed,
  fetchBranchesSucceeded,
} from "./branchesSlice";

export function* handleFetchBranches(action) {
  const { repo, product } = action.payload;
  try {
    const { data } = yield call(Branches.get, repo, product);
    const items = data && data.length > 0 ? data : [];

    const payload = {
      repo,
      branches: items.map(({ name }) => name),
    };

    yield put(fetchBranchesSucceeded(payload));
  } catch (error) {
    let response = error.response;
    let apiError;
    if (response?.data) {
      apiError = response.data;
    } else {
      apiError = error.message;
    }
    yield put(fetchBranchesFailed({ repo, error: apiError }));
  }
}

const watchers = [takeEvery(fetchBranchesRequested.type, handleFetchBranches)];

export default watchers;
